import React from 'react';

import { SvgIcon } from '@mui/material';

import type { SimpleIconInterface } from './icon-utils';

export function FolderOutlineIcon({ fill, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SvgIcon height={height ?? 24} viewBox="0 0 24 24" width={width ?? 24}>
      <path
        d="M10.99 6.77h8.625c1.18 0 2.135.955 2.135 2.134v9.692c0 1.18-.956 2.135-2.135 2.135H4.385c-1.18 0-2.135-.956-2.135-2.135V6.135C2.25 4.955 3.206 4 4.385 4h3.461c.672 0 1.305.316 1.708.854l1.436 1.915zm9.26 2.134c0-.35-.284-.635-.635-.635h-9c-.236 0-.458-.11-.6-.3L8.354 5.754c-.12-.16-.308-.254-.508-.254H4.385c-.35 0-.635.284-.635.635v12.461c0 .35.284.635.635.635h15.23c.35 0 .635-.284.635-.635V8.904z"
        fill={fill ?? '#324A52'}
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}
